import { render, staticRenderFns } from "./ImgFetched.vue?vue&type=template&id=261233ba&scoped=true&"
import script from "./ImgFetched.vue?vue&type=script&lang=ts&"
export * from "./ImgFetched.vue?vue&type=script&lang=ts&"
import style0 from "./ImgFetched.vue?vue&type=style&index=0&id=261233ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261233ba",
  null
  
)

export default component.exports